export const AnimatedBackground = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {/* White Background */}
      <div className="absolute inset-0 bg-white" />

      {/* Animated Blobs - More subtle for white background */}
      <div className="absolute inset-0">
        <div
          className="absolute w-[500px] h-[500px] rounded-full opacity-20 -top-[200px] -left-[200px] animate-float"
          style={{
            background: 'radial-gradient(circle, rgba(139, 92, 246, 0.15) 0%, transparent 70%)',
            filter: 'blur(80px)',
          }}
        />
        <div
          className="absolute w-[450px] h-[450px] rounded-full opacity-20 -bottom-[150px] -right-[150px] animate-float-delayed-10"
          style={{
            background: 'radial-gradient(circle, rgba(167, 139, 250, 0.15) 0%, transparent 70%)',
            filter: 'blur(80px)',
          }}
        />
        <div
          className="absolute w-[400px] h-[400px] rounded-full opacity-20 top-1/2 -right-[100px] animate-float-delayed-20"
          style={{
            background: 'radial-gradient(circle, rgba(196, 181, 253, 0.12) 0%, transparent 70%)',
            filter: 'blur(80px)',
          }}
        />
      </div>
    </div>
  );
};